import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { getConfig } from '../config/configuration';
import { useAppSelector } from '../store/hooks';

export const useRumContext = (): void => {
  const config = getConfig();
  const authentication = useAppSelector((state) => state.authentication);
  const { email, isAgent } = authentication;

  useEffect(() => {
    if (!config.ddRumEnabled) {
      return;
    }

    if (email && isAgent) {
      datadogRum.setUser({
        email
      });
    }
  }, [email, isAgent, config.ddRumEnabled]);
};
